import React from "react"
import { getButtonActionId, getTemporaryBlockId } from "../../../../../../../services/helpers/Helper";

const BlockPopover = (props) => {
   const { index, button, data, onSelectFaqByButtonAction, handleChangeButton } = props;
   let { buttons } = props;
   const getNodeName = () => {
      const blocks = data.blocks;
      let f = blocks.find(f => {
         return getTemporaryBlockId(f) === getButtonActionId(button.action);
      });
      return f?.title;
   }

   const handleRemove = () => {
      if (handleChangeButton) {
         buttons = buttons.map((m, i) => i === index ? { title: m.title } : m);
         handleChangeButton(buttons);
      }
   }

   return (
      <React.Fragment>
         <div className="width100 mb10 mt76">
            <label className="text-smaller">Hành động khi nhấn nút:</label>
            <div className="width100 mb5">
               <div className="card-button-editor-content-go-to-block btn btn-default block-display overflow-ellipsis button-action-pressed button-action-new-message-pressed">
                  <div className="display-flex pl20 height100 width85" onClick={() => onSelectFaqByButtonAction(button.action)}>
                     <a className="flex-display align-items-center width100">
                        <i className="fa ml5 mr15 font-size-23-i">
                           <svg ariahidden="true" focusable="false" dataprefix="far" dataicon="comment-dots" className="svg-inline--fa fa-comment-dots fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                              <path fill="currentColor"
                                 d="M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z">
                              </path>
                           </svg>
                        </i>
                        <span className="text-overflow-ellipsis">
                           <div className="text-button-action text-overflow-ellipsis text-font-weight-500">Tạo tin nhắn mới</div>
                           <div className="text-button-action-title text-overflow-ellipsis">{getNodeName()}</div>
                        </span>
                     </a>
                  </div>
                  <div className="width15 button-action-remove" onClick={handleRemove}>
                     <a>
                        <svg ariahidden="true" focusable="false" dataprefix="fas" dataicon="times" className="svg-inline--fa fa-times fa-w-11 text-bigger" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                           <path fill="currentColor"
                              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                           </path>
                        </svg>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </React.Fragment>
   )
}

export default BlockPopover